import React from 'react';
import { Chip, ChipProps, Tooltip } from '@mui/material';

import focusRing from '../../theme/focus';

// Marks a service that works and can be used for real, but may still change.
// It only informs: no click, no delete, no call for feedback. See chips.md 7.28.
const BetaChip = ({
  service,
  onMouseDown,
}: {
  // The service's name as customers see it, e.g. "Pingwin".
  service: string;
  onMouseDown?: ChipProps['onMouseDown'];
}) => (
  // describeChild keeps "Beta" as the accessible name and announces the tooltip as its
  // description; without it the tooltip text would replace the name.
  <Tooltip
    describeChild
    title={`${service} is in beta. It's ready to use, but how it looks and works may still change.`}
  >
    <Chip
      size="small"
      variant="outlined"
      label="Beta"
      // Focusable so keyboard users can reach the tooltip.
      tabIndex={0}
      onMouseDown={onMouseDown}
      sx={{
        flexShrink: 0,
        height: 22,
        bgcolor: 'background.paper',
        borderColor: 'divider',
        color: 'text.secondary',
        fontSize: 12,
        '&:focus-visible': { boxShadow: focusRing },
      }}
    />
  </Tooltip>
);

export default BetaChip;
